import { storeToRefs } from 'pinia';
import { useGlobalProperties } from '@/src/composables/useGlobalProperties';
import { inboxStore } from '@/src/store/inbox';
import { usersStore } from '@/src/store/users';
import { computed } from 'vue';

export default function useInbox() {
  const { getGlobalProperties } = useGlobalProperties();
  const { $route, $api, $auth, $toast, $messaging } = getGlobalProperties();

  const inbox = inboxStore();
  const { recepient, currentInbox } = storeToRefs(inbox);
  const { setSendingMessage, checkMessage, closeMessageModal } = inbox;

  const users = usersStore();
  const { usersInApp } = storeToRefs(users);

  if (!$api) {
    console.error('API instance is not available');
  }

  const opponentInfo = computed(() => {
    if (!currentInbox.value || !currentInbox.value.id) return null;
    return currentInbox.value.opponent_info;
  });

  const sendMessage = (message: string) => {
    if (!$auth.check()) {
      return false;
    }
    if (message === '' || message.trim() === '') {
      return false;
    }

    const recipient = recepient.value || opponentInfo.value.id;
    const requestData = {
      message,
      recepient_id: recipient,
      status: usersInApp.value.indexOf(recipient) === -1 ? 'offline' : 'online',
    };

    setSendingMessage(true);
    return $api
      .post('/api/user/inbox/message', requestData)
      .then((res: any) => {
        setSendingMessage(false);
        checkMessage(res.data);
        if (!'/dashboard/inbox'.includes($route.path)) {
          $toast({
            message: 'Your inbox message has been sent.',
            type: 'success',
          });
        }
        closeMessageModal();

        return res.data;
      })
      .catch((error: any) => {
        setSendingMessage(false);
        closeMessageModal();
        console.error(error, error.response);
        if (error.response) {
          $toast({
            message: `<b>Error: </b>${error.response.message || error.response}`,
            type: 'error',
          });
        } else if (error.response?.data) {
          $toast({
            message: `<b>Error: </b>${error.response.data}`,
            type: 'error',
          });
        }
        return false;
      });
  };

  const sendInboxImage = (result: any) => {
    const recipient = recepient.value || opponentInfo.value.id;
    const data = new FormData();
    data.append('type', 'image');
    data.append('recepient_id', recipient);
    data.append('status', users.usersInApp.indexOf(recipient) === -1 ? 'offline' : 'online');
    data.append('image', result, result.name);

    inbox.setSendingMessage(true);
    $api
      .post('/api/user/inbox/message', data)
      .then(() => {
        inbox.setSendingMessage(false);
        inbox.closeMessageModal();
      })
      .catch((error: any) => {
        inbox.setSendingMessage(false);
        inbox.closeMessageModal();
        console.error(error, error.response);

        if (error.response) {
          $toast({
            message: `<b>Error: </b>${error.response.message || error.response}`,
            type: 'error',
          });
        }
      });
  };

  const sendTypingMessage = (isTyping: boolean) => {
    const recipient = recepient.value || opponentInfo.value.id;
    $messaging.sendTypingInboxMessage('', recipient, currentInbox.value.id, isTyping);
  };

  return {
    opponentInfo,
    sendMessage,
    sendInboxImage,
    sendTypingMessage,
  };
}
